//
// LinearAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./NumericAxisOptions";
import "./AxisTickValueFitPolicy";
import "./AxisTickValueFormatOptions";
import "./AxisTickValueSequence";
import "./AxisTickValueRotation";
import "./AxisIncludeRangeEntry";

var LinearAxisOptions = createModule("gtl::LinearAxisOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::NumericAxisOptions"], EventDispatcher, [
    ,
    {
        tickValueSequence: 1,
        tickValueFormat: 1,
        centerOn: 6,
        origin: 6,
        tickDisplayList: [7],
        includeRanges: [1],
        integer: 2,
        tickValueFitPolicy: 4,
        minorTickCount: 4,
        tickValueRotation: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LinearAxisOptions;
